import moment from 'moment';

const defaultDateFormat = 'MM-DD-YYYY';
const strictDateCheck = true;
const format = (locale: string) => {
  let dateFormat: string;
  switch (locale) {
    case locale.startsWith('en') ? locale : '':
      dateFormat = defaultDateFormat;
      break;
    case locale.startsWith('es') ? locale : '':
      dateFormat = 'DD/MM/YYYY';
      break;
    default:
      dateFormat = defaultDateFormat;
  }
  return dateFormat;
};

const transformStringToDate = (date: string | Date) => {
  let newDate = date;
  if (typeof date === 'string') {
    newDate = new Date(date);
  }
  return newDate;
};

export const isDateValid = (date: string | Date, locale: string): boolean => {
  const newDate = transformStringToDate(date);
  const d = moment(newDate, format(locale), strictDateCheck);
  return d.isValid();
};

export const formatDate = (val: Date, locale: string) => (val ? moment(val).format(format(locale)) : '');

export const toDate = (date: string | Date, locale: string): Date => {
  const newDate = transformStringToDate(date);
  return moment(newDate, format(locale), strictDateCheck).toDate();
};
